import { render, staticRenderFns } from "./QuizLandingView.vue?vue&type=template&id=a5d8b5cc"
import script from "./QuizLandingView.vue?vue&type=script&lang=js"
export * from "./QuizLandingView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports